import { isEqual } from 'lodash'
import { Moment } from 'moment/moment'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { selectAssetDetailPage } from 'store/asset/selectors'

import { FIELD_NAMES } from '../validation'

export const useResidualServiceLifeDefault = (serviceLife?: number) => {
  const { watch } = useFormContext()
  const impairmentAt = watch(FIELD_NAMES.impaired_at) as Moment
  const { asset } = useSelector(selectAssetDetailPage, isEqual)

  if (!asset.usage_started_at || !impairmentAt || !serviceLife) return 1

  const numberYear = impairmentAt?.diff(asset.usage_started_at, 'years')
  return Math.max(1, serviceLife - numberYear)
}
